import { useEffect, useRef, useState } from "react";

export default function OnsenSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} id="onsen" className="py-20 md:py-28 bg-warm-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div
          className={`text-center mb-16 md:mb-20 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <p className="text-stone-500 text-xs tracking-[0.3em] mb-4">ONSEN</p>
          <h2 className="font-serif text-3xl md:text-4xl text-stone-900 mb-4">
            温泉・浴場のご案内
          </h2>
          <p className="text-stone-500 text-sm md:text-base max-w-lg mx-auto">
            天然温泉に身を委ねる。癒しの時間。
          </p>
        </div>
        <div
          className={`grid grid-cols-1 max-w-2xl mx-auto gap-6 md:gap-8 transition-all duration-700 delay-300 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="group">
            <div className="relative aspect-[4/3] rounded-2xl overflow-hidden mb-4">
              <img
                src="https://static.readdy.ai/image/68f89381c4c7240bb69246b185e50103/409e2540176589fdc010a01657f695ed.jpeg"
                alt="温泉民宿宝栄丸の岩風呂・天然温泉"
                width={800}
                height={600}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
              <span className="absolute bottom-5 left-5 bg-black/40 backdrop-blur-sm text-white text-lg font-bold tracking-widest font-serif px-4 py-1.5 rounded-lg">
                岩風呂
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}